/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Factories')
    .factory('DigitalSignService', DigitalSignService)

  DigitalSignService.$inject = ['$resource']

  function DigitalSignService ($resource) {
    return $resource(apiUrl + '/send-document', { id: '@id' }, {
      approveProposal: { method: 'POST', params: {}, isArray: false },
      approveDocuments: { url: apiUrl + '/approve-documents', method: 'POST', params: {}, isArray: false },
      updateDocumentsInfo: { url: apiUrl + '/update-documents-info', method: 'POST', params: {}, isArray: false },
      updateDocumentsInfoByCpf: { url: apiUrl + '/update-documents-info-by-cpf', method: 'POST', params: {}, isArray: false },
      sendDocumentsAgain: { url: apiUrl + '/send-documents-again', method: 'POST', params: {}, isArray: false },
      getDocumentList: { url: apiUrl + '/get-document-list', method: 'POST', params: {}, isArray: false },
      generateDocumentBySubscription: { url: apiUrl + '/generate-document', method: 'GET', params: {}, isArray: false },
      updateDocumentsInfoMultiple: { url: apiUrl + '/update-documents-info-multiple', method: 'POST' },
      saveResendSms: { url: apiUrl + '/save-resend-sms-clicksign', method: 'POST', params: {}, isArray: false },
      getContactsByFilters: { url: apiUrl + '/digital-signature/contacts', method: 'GET', params: {}, isArray: false },
      deleteContactProposal: { url: apiUrl + '/digital-signature/delete', method: 'DELETE', params: {}, isArray: false },
      approveProposalPayrollV2: { url: baseUrl + '/send-message/payroll-v2', method: 'POST', params: {}, isArray: false },
    })
  }
// eslint-disable-next-line semi
})();
